import { Text } from "@chakra-ui/react";

export const RequiredAst = () => (
  <Text color="red.500" display="inline">
    *
  </Text>
);
